module.exports = __webpack_public_path__ + "static/media/MIAB9780-180730-107_Small.2b219381.jpg";